import styled from 'styled-components';
import CheckIcon from '@mui/icons-material/Check';
import ArchivedIcon from '@mui/icons-material/Inventory2Outlined';
import { StatusFilterEnum } from '../../enums/StatusFilterEnum';
export const BadgeContainer = styled.div`
  display: flex;
  width: 100px;
  height: 32px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  font-family: ${({ theme }) => theme.fonts.family.inter};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  ${({ status, theme }) =>
    status === StatusFilterEnum.ACTIVE
      ? `
        color: ${theme.status.active.text};
        background: ${theme.status.active.background};
      `
      : `
        border: 1px solid ${theme.colors.clearGray};
        background: ${theme.colors.veryLightGray};
        color: ${theme.colors.asphaltBlue};
      `}
`;

export const StyledCheckIcon = styled(CheckIcon)`
  font-size: 14px !important;
  margin-right: 4px;
  color: ${({ theme }) => theme.status.active.text} !important;
`;

export const StyledArchivedIcon = styled(ArchivedIcon)`
  font-size: 14px !important;
  margin-right: 4px;
  color: ${({ theme }) => theme.colors.asphaltBlue} !important;
`; 